import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getDynaFields() {
  const data = await apiGet('helper/dynafields');
  useHelperStore().setDynaFields(data);
}
